import React from 'react';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';

export const MobileHelperText = () => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (!isEmbeddedMobile) {
    return null;
  }

  return (
    <Text
      as="p"
      maxWidth={220}
      color="neutral.400"
      fontSize="small"
      my="16"
      mx="auto"
      textAlign="center"
    >
      If you need to see additional details, please visit the web portal.
    </Text>
  );
};
